/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-19 17:41:18
 * @LastEditTime: 2019-07-24 14:32:50
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  普通仓库需求管理接口Url
const websiteDemandUrl = '/website/storage/demand'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

/* 邀请查看接口 */
const invitationSaveUrl = `/website/warehousing/invitation`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 邀请查看列表
export function invitationSave(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + invitationSaveUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'save'
      }, param))
    }
  })
}

// 批量发布
export function issueBatch(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'issueBatch'
      }, param))
    }
  })
}

// 分页查询普通仓库需求列表
export function findPageDemand(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemandRecommend'
      }, param))
    }
  })
}

// 修改数据普通仓库需求列表
export function demandEdit(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandEdit'
      }, param))
    }
  })
}

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 删除普通仓库需求列表
export function demandRemove(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandRemove'
      }, param))
    }
  })
}

// 批量删除普通仓库需求列表
export function delBatch(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'delBatch'
      }, param))
    }
  })
}

// 查询仓库需求详情信息
export function findDemandById(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websiteDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findDemandById'
      }, param))
    }
  })
}

//  普通仓库需求管理接口Url
const websitetankDemandUrl = '/website/tankFarm/demand'

// 分页查询普通仓库需求列表
export function tankfindPageDemand(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + websitetankDemandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemandRecommend'
      }, param))
    }
  })
}

/* 收藏接口 */
const conllectionUrl = `/website/personal/conllection/save`

/* 收藏货源 */
export function conllection(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + conllectionUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'saveCollection'
      }, param))
    }
  })
}
